import React, { SVGProps } from 'react';

const SvgVrpano = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' fill='currentColor' className='svg-icon' {...props}>
			<path fill='none' d='M0 0h24v24H0z' />
			<path
				d='M4 6.38v11.25c2.01-.59 4.61-1.13 8-1.13 3.38 0 5.99.54 8 1.13V6.37c-2.01.59-4.62 1.13-8 1.13-2.68 0-5.42-.39-8-1.12zm14.51 9.02c-1.99-.25-4.21-.4-6.51-.4-2.34 0-4.52.15-6.52.41l3.69-4.42 2 2.4L14 10l4.51 5.4z'
				opacity={0.3}
			/>
			<path d='M21.01 4C20.45 4 17.4 5.5 12 5.5c-5.31 0-8.49-1.49-9.01-1.49-.53 0-.99.44-.99 1.01V19c0 .57.46 1 .99 1 .57 0 3.55-1.5 9.01-1.5 5.42 0 8.44 1.5 9.01 1.5.53 0 .99-.43.99-1V5c0-.57-.46-1-.99-1zM20 17.63c-2.01-.59-4.62-1.13-8-1.13-3.39 0-5.99.54-8 1.13V6.38c2.58.73 5.32 1.12 8 1.12 3.38 0 5.99-.54 8-1.13v11.26z' />
			<path d='M9.17 10.99l-3.69 4.42c2-.26 4.18-.41 6.52-.41 2.3 0 4.52.15 6.51.4L14 10l-2.83 3.39-2-2.4z' />
		</svg>
	);
};

export default SvgVrpano;
